// @flow
import React, { Fragment } from 'react';
import EventHead from 'components/event/EventHead';
import EventContent from '../EventContent';
import './EventPlaceholder.scss';

type Props = {};

const EventPlaceholder = (props: Props) => (
  <Fragment>
    <EventHead.Placeholder />
    <EventContent.Placeholder />
  </Fragment>
);

export default EventPlaceholder;



// WEBPACK FOOTER //
// ./src/components/event/EventPlaceholder/EventPlaceholder.js